import { useTranslation } from "react-i18next";

export default function ErrorFallback() {
  const { t } = useTranslation();
  return (
    <div
      className="flex h-screen w-screen flex-col items-center justify-center text-red-500"
      role="alert"
    >
      <h2 className="text-lg font-semibold">{t("errorFallbackTitle")}</h2>
      <button
        className="mt-4"
        onClick={() => window.location.assign(window.location.origin)}
      >
        {t("refresh")}
      </button>
    </div>
  );
}
